var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.22392V4.49992H11.8333V3.16659C11.8333 2.81296 11.6929 2.47382 11.4428 2.22378C11.1928 1.97373 10.8536 1.83325 10.5 1.83325H6.5C6.14638 1.83325 5.80724 1.97373 5.55719 2.22378C5.30714 2.47382 5.16667 2.81296 5.16667 3.16659V4.49992H6.5V8.22392L4.69533 9.36192C4.63331 9.42372 4.58411 9.49718 4.55059 9.57807C4.51707 9.65897 4.49987 9.74569 4.5 9.83325V11.1666C4.5 11.3434 4.57024 11.513 4.69526 11.638C4.82029 11.763 4.98986 11.8333 5.16667 11.8333H7.83333V13.8333L8.5 15.1666L9.16667 13.8333V11.8333H11.8333C12.0101 11.8333 12.1797 11.763 12.3047 11.638C12.4298 11.513 12.5 11.3434 12.5 11.1666V9.83325C12.5001 9.74569 12.4829 9.65897 12.4494 9.57807C12.4159 9.49718 12.3667 9.42372 12.3047 9.36192L10.5 8.22392Z",
    fill: "#EE3B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/LocationPin.8cccd83c6de42996047412160bc20525.svg";
export { ForwardRef as ReactComponent };